export default Object.freeze({
  Json: 'json',
  Text: 'text',
  Csv: 'csv',
  Xml: 'xml',
  Parquet: 'parquet',
});
